import React from 'react';
import proptypes from 'prop-types';
import { UserMessagingDialog } from './user-messaging';
import { Box, CardHeader, IconButton, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { useAuthUser } from 'components/shared/hooks/useAuthUser';
import { useSingleUser, USER_LOADED_STATUS } from 'features/users';
import { useHistory } from 'react-router-dom';

const EstheticianNotSetMessage = ({ cancel, ok }) => {
  const { push } = useHistory();
  const handleClick = () => {
    push('/find-an-esthetician');
    ok();
  };

  return (
    <>
      <CardHeader
        color="primary"
        title={'Messaging'}
        titleTypographyProps={{ variant: 'h6' }}
        action={
          <IconButton onClick={cancel}>
            <Close />
          </IconButton>
        }
      />
      <Box sx={{ p: 3, textAlign: 'center', mt: '30vh' }}>
        <Typography
          variant={'body1'}
          sx={{ mt: 3, fontSize: 21, lineHeight: '31px', color: '#949494' }}
        >
          You are not assigned to an esthetician.
        </Typography>
        <Typography
          variant={'body1'}
          sx={{ mt: 2, fontSize: 21, lineHeight: '31px', color: '#949494' }}
        >
          <Box
            sx={{
              color: 'primary.main',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            component={'span'}
            onClick={handleClick}
          >
            Find an esthetician
          </Box>{' '}
          to get started!
        </Typography>
      </Box>
    </>
  );
};

EstheticianNotSetMessage.propTypes = {
  cancel: proptypes.func,
  ok: proptypes.func,
};

/** TODO: Collapse UserMessagingDialog and EstheticianMessagingDialog into one.
 * It's more flexible to use the notion of incoming / outgoing messages instead
 * of whether they're from estheticians / clients, especially when we introduce
 * Pomp Concierge.
 */
const EstheticianMessagingDialog = ({ cancel, ok }) => {
  const user = useAuthUser();
  const { user: loggedInUser, loading: authUserLoading } = useSingleUser(
    user.id
  );
  const { user: estheticianUser, loading: estheticianLoading } = useSingleUser(
    loggedInUser?.estheticianId,
    false,
    USER_LOADED_STATUS.BASIC
  );

  if (authUserLoading || estheticianLoading) return null;
  if (!estheticianUser)
    return <EstheticianNotSetMessage cancel={cancel} ok={ok} />;

  return (
    <UserMessagingDialog
      userId={loggedInUser.id}
      isEsthetician={loggedInUser.role === 'esthetician'}
      estheticianId={estheticianUser.id}
      cancel={cancel}
    />
  );
};

EstheticianMessagingDialog.propTypes = {
  userActions: proptypes.object,
  cancel: proptypes.func,
  ok: proptypes.func,
};

export { EstheticianMessagingDialog };
